// ─── App Setting Var Types ──────────────────────────────────────────────────
/**
 * A settings list's items as choices, skipping any without a value and
 * naming one without a label by its value. A list's items are JSON the
 * office edits, so nothing about their shape is taken on trust.
 */
export function settingListOptions(items) {
    if (!Array.isArray(items))
        return [];
    return items.flatMap((raw) => {
        const item = raw;
        if (!item || typeof item.value !== 'string' || !item.value.trim())
            return [];
        const label = typeof item.label === 'string' && item.label.trim() ? item.label : item.value;
        return [{ value: item.value, label }];
    });
}
//# sourceMappingURL=app-settings.js.map